import React, { useCallback } from "react";
import { Input, makeStyles } from "@fluentui/react-components";

/* global HTMLInputElement */

const useStyles = makeStyles({
  fullWidth: {
    width: "100%",
    minWidth: "0",
  },
});

interface InputFieldProps {
  value?: string;
  placeholder?: string;
  required?: boolean;
  onChange: (value: string) => void;
}

export const InputField: React.FC<InputFieldProps> = ({
  value,
  placeholder,
  required,
  onChange,
}) => {
  const styles = useStyles();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );

  return (
    <Input
      className={styles.fullWidth}
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      required={required}
    />
  );
};

export default React.memo(InputField);
